import { format, startOfMonth } from 'date-fns';
import React, { useContext, useEffect, useState } from 'react';
import ReportHeader from '../../../../components/Search/ReportHeader';
import ReportSortArrows from '../../../../components/Search/ReportSortArrows';
import { PostData } from '../../../../services/FetchData';
import { buildReportRequestPayload, getActiveWebsiteId } from '../../../../utils/reportUtils';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { Table } from 'reactstrap';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import TableSkeleton from '../../../../components/Skeleton/TableSkeleton';
import ReactPaginate from 'react-paginate';
import { ProductContext } from '../../../../store';

const NoResult = () => {
	const [pageLoader, setPageLoader] = useState(true),
		[tableLoader, setTableLoader] = useState(true),
		[totalPageCount, setTotalPageCount]	= useState(0),
		[noResults, setNoResults]	= useState([]),
		[sortField, setSortField] = useState(null),
		[sortOrder, setSortOrder] = useState("desc"),
		{
			currentWebsiteId,
			dateRange,
			setDateRange
		} = useContext(ProductContext),
		[limit, setLimit] = useState(25),
		[page, setPage] = useState(0)

	useEffect(() => {
		if (getActiveWebsiteId(currentWebsiteId)) {
			getReports()
		}
	}, [dateRange, limit, page, currentWebsiteId, sortField, sortOrder])

	const handleSort = (field, e) => {
        e?.stopPropagation?.();
		if (sortField === field) {
			setSortOrder(sortOrder === "asc" ? "desc" : "asc");
		} else {
			setSortField(field);
			setSortOrder("desc");
		}
		setPage(0);
	};
	const setSort = (field, order, e) => {
		e?.stopPropagation?.();
		setPage(0);
		setSortField(field);
		setSortOrder(order);
	};


	const getReports = () => {
		setTableLoader(true)
				const websiteId = getActiveWebsiteId(currentWebsiteId);
		if (!websiteId) {
		    setTableLoader(false);
		    setPageLoader(false);
		    return;
		}
		const data = {
		    websiteId,
				startDate: format(dateRange.startDate, "yyyy-MM-dd"),
				endDate: format(dateRange.endDate, "yyyy-MM-dd"),
				page: page+1,
				limit,
				sortField: sortField || "",
				sortOrder: sortOrder || "desc",
			}
		PostData("ms1", "api/v1/analytics/getNoResults", data).then(response => {
			if (response !== "Invalid" && response !== "undefined") {
				if (response.status === "success") {
					setNoResults(response.data.popularSearchNoResultData)
					let totalRecord	= response.data.pagination.totalRecords,
						totalPage	= Math.ceil(totalRecord/limit)
					setTotalPageCount(totalPage)
				} else if (response.status === "failure") {
					toast.error(response.message)
				} else {
					toast.error(response.message.message)
				}
			}
			setTableLoader(false)
			setPageLoader(false)
		})
	}

	return (
		<div>
			{pageLoader ?
				<DetailSkeleton />
			:
				<React.Fragment>
					<ReportHeader range={dateRange} onDateChange={(range) => setDateRange(range)} />
					<div className="tab-content mt-3">
						<div className="d-flex justify-content-end align-items-center">
							{/* <h3>Search Phrase</h3> */}
							<div className="d-flex align-items-center">
								<label htmlFor="limit" className="me-2">
									Items Per Page:
								</label>
								<select id="limit" className="form-select" value={limit} onChange={(e) => setLimit(Number(e.target.value))} style={{ width: "100px", fontSize: "12px" }}>
									<option value={25}>25</option>
									<option value={30}>30</option>
									<option value={50}>50</option>
									<option value={100}>100</option>
								</select>
							</div>
						</div>
						<div>
							{tableLoader ?
								<TableSkeleton />
							:
								<Table className={`table ${noResults.length > 0 ? "table-striped" : ""} mt-3 custom-bordered-table`}>
									<thead>
										<tr>
											<th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("_id", e)}>
                                                <div className="sortable-header-inner">
                                                    Search Term
                                                    <ReportSortArrows field="_id" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
											<th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("count", e)}>
                                                <div className="sortable-header-inner">
                                                    Search Count
                                                    <ReportSortArrows field="count" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
										</tr>
									</thead>
									<tbody>
										{noResults.length === 0 ? (
											<tr>
												<td colSpan={2}>
													<div className="emptyPlaceholder">
														<div>
															<div>
																<img src={require("./../../../../assets/images/paper-plane-grey.png")} className='img-fluid' alt="No data found" />
															</div>
															<div className="rsInfoMsg disabled">
																<div className="flex-1">No records found.</div>
															</div>
														</div>
													</div>
												</td>
											</tr>
										) : (
											noResults.map((row, index) => (
												<tr key={index}>
													<td>{row._id}</td>
													<td>{row.count}</td>
												</tr>
											))
										)}
									</tbody>
								</Table>
							}
							{totalPageCount > 1 &&
								<div className='d-flex justify-content-center mt-5'>
									<ReactPaginate
										nextLabel=">"
										onPageChange={(event) => setPage(event.selected)}
										page={page}
										pageRangeDisplayed={3}
										marginPagesDisplayed={2}
										pageCount={totalPageCount}
										previousLabel="<"
										pageClassName="page-item"
										pageLinkClassName="page-link"
										previousClassName="page-item"
										previousLinkClassName="page-link"
										nextClassName="page-item"
										nextLinkClassName="page-link"
										breakLabel="..."
										breakClassName="page-item"
										breakLinkClassName="page-link"
										containerClassName="pagination"
										activeClassName="active"
										renderOnZeroPageCount={null}
									/>
								</div>
							}
						</div>
					</div>
				</React.Fragment>
			}
		</div>
	);
};

export default NoResult;
